import { render, staticRenderFns } from "./LoseModal.vue?vue&type=template&id=8a5bb7d4&scoped=true"
import script from "./LoseModal.vue?vue&type=script&lang=js"
export * from "./LoseModal.vue?vue&type=script&lang=js"
import style0 from "./LoseModal.vue?vue&type=style&index=0&id=8a5bb7d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5bb7d4",
  null
  
)

export default component.exports